import { render, staticRenderFns } from "./cadrotas.vue?vue&type=template&id=88cd284a&"
import script from "./cadrotas.vue?vue&type=script&lang=js&"
export * from "./cadrotas.vue?vue&type=script&lang=js&"
import style0 from "./cadrotas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports